import { Avatar, AvatarProps } from '@material-ui/core';
import CodeIcon from '@material-ui/icons/Code';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import PublicIcon from '@material-ui/icons/Public';
import SettingsIcon from '@material-ui/icons/Settings';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { IdentityKind, identityKind } from '../../utils';

export type IdentityAvatarProps = Omit<AvatarProps, 'children'> & {
  identityRef?: IdentityRefFragment | null;
};

const getIcon = (kind: IdentityKind) => {
  switch (kind) {
    case 'user':
      return <PersonIcon />;
    case 'apiClient':
      return <CodeIcon />;
    case 'service':
      return <SettingsIcon />;
    case 'group':
      return <GroupIcon />;
    case 'everyone':
      return <PublicIcon />;
    default:
      return null;
  }
};

export const IdentityAvatarBase = (
  props: IdentityAvatarProps & { avatarSrc?: string },
) => {
  const { identityRef, avatarSrc, ...avatarProps } = props;

  const kind = identityRef?.name ? identityKind(identityRef.name) : undefined;

  return (
    <Avatar
      {...(kind === 'user' ? { 'data-csr-block': true } : {})}
      {...avatarProps}
      src={avatarSrc}
      title={identityRef?.displayName ?? undefined}
    >
      {kind && getIcon(kind)}
    </Avatar>
  );
};
